import { MAX_IMAGES_PER_ITEM } from '@easymoving/types';

/**
 * Thrown when a photo upload would exceed a client-visible cap. The UI catches
 * it to show a friendly message rather than the generic "upload failed" toast.
 * (The server-side per-user cap + kill-switch are enforced in Storage rules;
 * this is the per-item UX guard, shared by the upload UI and the data layer.)
 */
export class ImageLimitError extends Error {
  constructor(message = 'image limit reached') {
    super(message);
    this.name = 'ImageLimitError';
  }
}

/** How many more photos this item can take before hitting the per-item cap. */
export function remainingItemImageSlots(currentCount: number): number {
  return Math.max(0, MAX_IMAGES_PER_ITEM - currentCount);
}

/** Throw if the item is already at the per-item photo cap. */
export function assertUnderItemImageCap(currentCount: number): void {
  if (currentCount >= MAX_IMAGES_PER_ITEM) {
    throw new ImageLimitError(`per-item photo cap (${MAX_IMAGES_PER_ITEM}) reached`);
  }
}
